<div [cfaLoading]="isLoading">
  <form [formGroup]="switchForm">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Switch</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <div class="form-field-wrapper">
          <mat-form-field appearance="outline">
            <mat-label>Serial</mat-label>
            <input matInput formControlName="serial">
            @if (switchForm.get('serial').hasError('required')) {
              <mat-error>
                Please enter a serial number
              </mat-error>
            }
            @if (switchForm.get('serial').hasError('minLength')) {
              <mat-error>
                Please enter a valid 12 character serial number
              </mat-error>
            }
            @if (switchForm.get('serial').hasError('maxLength')) {
              <mat-error>
                Please enter a valid 12 character serial number
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>